<template>
  <div v-loading="loading" class="page-form">

    <h3 class="title">发货取消申请</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
        <btky-header
          :form-data="conditions"
          :process-key="processKey"
          @formDataSave="saveData"
          @validate="validate"
        />
      </div>
      <el-form ref="form" inline :disabled="conditions.status === 3" size="mini" label-width="110px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="申请人">
              <el-input v-model="conditions.createdByName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请时间">
              <el-input v-model="conditions.createdDate" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="所属部门">
              <el-input v-model="conditions.deptName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发货单号">
              <el-input v-model="conditions.orderNo" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编码">
              <el-input v-model="conditions.partner" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.partnerName"  disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="16" :md="12">
            <el-form-item label="取消原因">
              <el-input v-model="conditions.comment" type="textarea" rows="3" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="安吉核实情况"
        :show-custome="false"
      >
        <el-checkbox v-model="conditions.cancelFlag" size="mini" :disabled="conditions.status === 0 || conditions.status === 3" true-label="1" false-label="0">可以退货 </el-checkbox>
        <!--div style="margin-top: 10px">
          <span>确认信息:</span>
          <el-input v-model="conditions.feedback" size="mini" :disabled="conditions.status === 0 || conditions.status === 3" type="textarea" rows="3" />
        </div-->
         </TableCommon>

      <btky-footer :form-data="conditions" />
    </div>
  </div>
</template>

<script>
import { apiCancelToGoodsDetail } from '@/api/applyForGoods/index'
import { handlerFlow } from '@/api/flowHander'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      processKey: 'cancelPurchaseOrder',
      rules: {},
      loading: false,
      wantCode: 'FH20001123',
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        procInstId: '',
        orderNo: '',
        orderId: '',
        parnter: '',
        deptName: '',
        partner: '',
        partnerName: '',
        createdByName: '',
        createdDate: '',
        feedback: '',
        comment: '',
        cancelFlag: '0',
        status: 0
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    const { orderId, orderNo, id, taskId , customerCode, customerName} = this.$route.query
    if (id) {
      this.getDetail(id, taskId)
    } else {
      this.conditions.orderNo = orderNo
      this.conditions.orderId = orderId
      this.conditions.partner = customerCode
      this.conditions.partnerName = customerName
      this.conditions.createdByName = this.userInfo.name
      this.conditions.createdDate = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.conditions.deptName = this.userInfo.deptName

     // this.conditions.partnerName = this.$store.getters.role.USER_NAME
      this.conditions.partner = this.$store.getters.role.USER_BP
    }
  },
  methods: {
    async getDetail(id, taskId) {
      const { data } = await apiCancelToGoodsDetail({ id })
      Object.assign(this.conditions, data)
      this.conditions.taskId = taskId
      this.conditions.bizId = id
    },
    saveData() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.conditions))
      handlerFlow(params, this.processKey).then(res => {
        this.loading = false
        if (!this.conditions.id) {
          Object.assign(this.conditions, res.data.bizData)
          this.conditions.id = res.data.bizId
          this.conditions.bizId = res.data.bizId
          this.conditions.taskId = res.data.taskId
          this.conditions.procInstId = res.data.bizprocInstId
          this.$message.success('保存成功')
        }
      })
    },
    validate(cb) {
      cb()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/cancelToGoods.vue